import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import WizardError from "../auth/register/WizardError";
import Flex from "../common/Flex";
import ButtonIcon from "../common/ButtonIcon";
import { faSave, faUndo } from "@fortawesome/free-solid-svg-icons";
import { PreloadState } from "../UI/preloading/PreloadState";
import { createParking } from "../../helpers/api/parking";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import SupportLink from "../root/support/components/SupportLink";

const CreateParking = () => {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange", reValidateMode: "onChange" });
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [submitting, setSubmitting] = useState(false);

  const save = (values) => {
    setSubmitting(true);
    createParking(selectedCondominium, values)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.CREATED) {
          Toast.fire({
            type: "success",
            title: `Estacionamiento registrado exitosamente.`,
          });
          history.push("/dashboard/parking");
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <PageHeader
        title="Estacionamiento"
        titleTag="h2"
        description={
          "Si necesitas ayuda comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card tag={Form} onSubmit={handleSubmit(save)}>
        <PreloadState
          loading={submitting}
          message="Registrando por favor espere..."
        >
          <CardHeader>
            <h5>Registro de estacionamiento</h5>
          </CardHeader>
          <CardBody className="bg-light">
            <Row form>
              <Col tag={FormGroup}>
                <Label>Acrónimo del estacionamiento</Label>
                <Input
                  type="text"
                  className={`${
                    errors?.acronym?.message ? "border-danger" : ""
                  } form-control input-spin-none`}
                  maxLength={3}
                  name="acronym"
                  innerRef={register({
                    required: {
                      value: true,
                      message: "El acrónimo es requerido.",
                    },
                  })}
                />
                {errors.acronym && (
                  <WizardError
                    error={errors?.acronym?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                )}
              </Col>
            </Row>
            <Row form>
              <Col tag={FormGroup}>
                <Label>Descripción del estacionamiento</Label>
                <Input
                  className={`${
                    errors?.description?.message ? "border-danger" : ""
                  } form-control input-spin-none`}
                  type="textarea"
                  rows="4"
                  name="description"
                  innerRef={register({
                    required: {
                        value: true,
                        message: "La descripción es requerida.",
                      },
                    minLength: {
                      value: 5,
                      message:
                        "La descripción debe tener al menos 5 carácteres.",
                    },
                  })}
                />
                {errors.description && (
                  <WizardError
                    error={errors.description.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                )}
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Flex align="center" justify="end">
              <ButtonIcon
                color="light"
                className="px-5 mr-2"
                size="md"
                onClick={() => history.push("/dashboard/parking")}
                icon={faUndo}
              >
                Volver
              </ButtonIcon>
              <ButtonIcon
                color="primary"
                className="px-5 ml-2"
                size="md"
                type="submit"
                /* disabled={!isValid} */ icon={faSave}
              >
                Registrar
              </ButtonIcon>
            </Flex>
          </CardFooter>
        </PreloadState>
      </Card>
    </>
  );
};

export default CreateParking;
